import { TFunction } from 'i18next';
import { EMAIL_NS } from '@/Domain/components/Integration/Email/email.const';

export const replyDelayLabel = (t: TFunction, minutes: number): string =>
  minutes === 0
    ? t(`${EMAIL_NS}.reply_delay.immediate`)
    : t(`${EMAIL_NS}.reply_delay.minutes`, { count: minutes });
